import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import ThreeDViewer from './3dViewer';
const CardComponent = ({ id, ref_id, title, media, media_type, project, record_date }) => {
  
  const [items, setItems] = useState([]);

  const deleteItem = async (id) => {
    try {
      await fetch(`/api/delete/${id}`, {
        method: "DELETE",
      });

      setItems(items.filter(item => item.obj_id !== id));
      window.location.reload();
    } catch (err) {
      console.error("Error deleting item:", err);
    }
  };

  const isVideo = media_type && Array.isArray(media_type) && media_type[0].toLowerCase() === 'video';
  const is3DModel = media_type && Array.isArray(media_type) && media_type[0].toLowerCase() === '3d';

  return (
    <Fragment>
      <Link to={`/item/${id}`}>
<div className="itemcard">
  <div className="cardcontent">
    <div className="cardmediaspace">
      {isVideo ? (
        
        <video className="cardvideo" controls>
          <source
            src={`/api/uploads/thumbnails/${media}`}
            type="video/mp4" 
          />
          Your browser does not support the video tag.
        </video>
      ) : is3DModel ? (
        <div className="detail3d"> <ThreeDViewer  objPath={`/api/uploads/thumbnails/${media}`} />
      </div>
        ) : (
        <img 
        className="cardimg" 
        src={`/api/uploads/thumbnails/${media}`} 
        alt={title} 
      />
      )}
    </div>

          <div className="cardbottom">
            <h3 className="card_title">{title}</h3>
            <div>
              <p className="card_text">ID= {ref_id}</p>
              <p className="card_text">Project= {project}</p>
              <p className="card_text">Record Date= {record_date}</p>
              <p className="card_text">Media Type= {media_type}</p>
            </div>
           
          </div>
        </div>
      </div>
      </Link>
    </Fragment>
  );
};

export default CardComponent;
